import { Suspense, lazy } from 'react';
import { Navigate, RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Home = Loader(lazy(() => import('src/content/home')));
const Users = Loader(lazy(() => import('src/content/users')));
const Employees = Loader(lazy(() => import('src/content/employees')));
const AddUser = Loader(lazy(() => import('src/content/users/add-user')));
const Roles = Loader(lazy(() => import('src/content/roles')));
const AddRole = Loader(lazy(() => import('src/content/roles/add-role')));
const AddExtension = Loader(lazy(() => import('src/content/add-extension')));
const AddEmployee = Loader(lazy(() => import('src/content/add-employee')));
const TodayReport = Loader(lazy(() => import('src/content/today-report')));
const ExtensionReports = Loader(
  lazy(() => import('src/content/today-report/ex-reports'))
);
const CancelledCalls = Loader(
  lazy(() => import('src/content/cancelled-calls'))
);

const Profile = Loader(lazy(() => import('src/content/auth/profile')));

const routes: RouteObject[] = [
  // {
  //   path: '',
  //   element: <BaseLayout />,
  //   children: [

  //     {
  //       path: '*',
  //       element: <Navigate to="/dashboards/crypto" replace />
  //     },
  //     {
  //       path: 'status',
  //       children: [
  //         {
  //           path: '',
  //           element: <Navigate to="404" replace />
  //         },
  //         {
  //           path: '404',
  //           element: <Status404 />
  //         },
  //         {
  //           path: '500',
  //           element: <Status500 />
  //         },
  //         {
  //           path: 'maintenance',
  //           element: <StatusMaintenance />
  //         },
  //         {
  //           path: 'coming-soon',
  //           element: <StatusComingSoon />
  //         }
  //       ]
  //     },
  //     {
  //       path: '*',
  //       element: <Status404 />
  //     }
  //   ]
  // },
  {
    path: '*',
    element: <Navigate to="/home" />
  },
  {
    path: 'home',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Home />
      }
    ]
  },
  {
    path: 'profile',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Profile />
      }
    ]
  },
  {
    path: 'users',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Users />
      },
      {
        path: ':id',
        element: <AddUser />
      },
      {
        path: 'create',
        element: <AddUser />
      }
    ]
  },
  {
    path: 'employees',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Employees />
      },
      {
        path: 'create',
        element: <AddEmployee />
      },
      {
        path: ':id',
        element: <AddEmployee />
      }
    ]
  },
  {
    path: 'roles',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Roles />
      },
      {
        path: 'create',
        element: <AddRole />
      }
    ]
  },
  {
    path: 'add-extension',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <AddExtension />
      }
    ]
  },
  // {
  //   path: 'employees',
  //   element: <SidebarLayout />,
  //   children: [{ path: ':id', element: <AddEmployee /> }]
  // },
  // {
  //   path: 'add-employee',
  //   element: <SidebarLayout />,
  //   children: [
  //     {
  //       path: '',
  //       element: <AddEmployee />
  //     }
  //   ]
  // },
  {
    path: 'reports',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <TodayReport />
      },
      {
        path: 'extension/:id',
        element: <ExtensionReports />
      }
    ]
  },
  {
    path: 'cancelled-calls',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <CancelledCalls />
      }
    ]
  }
  // {
  //   path: 'dashboards',
  //   element: <SidebarLayout />,
  //   children: [
  //     {
  //       path: '',
  //       element: <Navigate to="crypto" replace />
  //     },
  //     {
  //       path: 'crypto',
  //       element: <Crypto />
  //     },
  //     {
  //       path: 'messenger',
  //       element: <Messenger />
  //     }
  //   ]
  // },
  // {
  //   path: 'management',
  //   element: <SidebarLayout />,
  //   children: [
  //     {
  //       path: '',
  //       element: <Navigate to="transactions" replace />
  //     },
  //     {
  //       path: 'transactions',
  //       element: <Transactions />
  //     },
  //     {
  //       path: 'profile',
  //       children: [
  //         {
  //           path: '',
  //           element: <Navigate to="details" replace />
  //         },
  //         {
  //           path: 'details',
  //           element: <UserProfile />
  //         },
  //         {
  //           path: 'settings',
  //           element: <UserSettings />
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   path: '/components',
  //   element: <SidebarLayout />,
  //   children: [
  //     {
  //       path: '',
  //       element: <Navigate to="buttons" replace />
  //     },
  //     {
  //       path: 'buttons',
  //       element: <Buttons />
  //     },
  //     {
  //       path: 'modals',
  //       element: <Modals />
  //     },
  //     {
  //       path: 'accordions',
  //       element: <Accordions />
  //     },
  //     {
  //       path: 'tabs',
  //       element: <Tabs />
  //     },
  //     {
  //       path: 'badges',
  //       element: <Badges />
  //     },
  //     {
  //       path: 'tooltips',
  //       element: <Tooltips />
  //     },
  //     {
  //       path: 'avatars',
  //       element: <Avatars />
  //     },
  //     {
  //       path: 'cards',
  //       element: <Cards />
  //     },
  //     {
  //       path: 'forms',
  //       element: <Forms />
  //     }
  //   ]
  // }
];

export default routes;
